import React from 'react';
import { values } from 'lodash';

class CriterionCountPerRating extends React.Component {
  constructor(props) {
    super(props);
    this.calculateBarHeight = this.calculateBarHeight.bind(this);
  }

  calculateBarHeight(count) {
    const MAX_HEIGHT = 20;
    const MIN_HEIGHT = 2;
    const maxCountOfRatings = Math.max(...values(this.props.data));
    const calculatedBarHeight =
      parseFloat(count / maxCountOfRatings) * MAX_HEIGHT;
    const returnMinHeight = count === 0 || calculatedBarHeight <= MIN_HEIGHT;
    const returnMaxHeight =
      maxCountOfRatings === count && maxCountOfRatings !== 0;
    if (returnMaxHeight) {
      return MAX_HEIGHT;
    }
    if (returnMinHeight) {
      return MIN_HEIGHT;
    }
    return calculatedBarHeight.toPrecision(4);
  }

  render() {
    const { data } = this.props;
    const newRatingsText = [
      t('insights.criterion.new_ratings.one'),
      t('insights.criterion.new_ratings.two'),
      t('insights.criterion.new_ratings.three'),
      t('insights.criterion.new_ratings.four'),
      t('insights.criterion.new_ratings.five'),
    ];

    return (
      <div className="CriterionCountPerRating d-f jc-c">
        {Object.entries(data).map((key, index) => (
          <div
            key={key[0]}
            data-toggle="tooltip"
            title={`${key[1]} ${newRatingsText[index]} ${t(
              'insights.criterion.new_ratings.suffix',
            )}`}
            data-placement="top"
            className="CriterionCountPerRating-container"
          >
            <div
              style={{ height: `${this.calculateBarHeight(key[1])}px` }}
              className="CriterionCountPerRating-bar"
            />
          </div>
        ))}
      </div>
    );
  }
}

export default CriterionCountPerRating;
